module.exports = __webpack_public_path__ + "media/images/cloud-attract-badge-tiny-b6ff9f70.svg";